module.exports = __webpack_public_path__ + "static/img/warning.8710411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warning.png
// module id = BWa7
// module chunks = 1